import { useCallback } from 'react';

import { type FavoritePromptsRequest } from '@atlassian/conversation-assistant-service-api/types/assistance-service';
import {
	type AssistanceServiceInjectedParams,
	type AssistanceServiceInputParam,
	createHookWithAssistanceService,
} from '@atlassian/conversation-assistant-service/services/assistance-service/main';

type UseFavoritePromptsControllerProps = AssistanceServiceInjectedParams;

export type UseFavoritePromptsControllerResult = {
	favoritePrompts: (payload: FavoritePromptsRequest) => Promise<void>;
};

/**
 * Returns a function to favorite/unfavorite prompts via the assistance service POST /api/v2/prompts/favorite endpoint.
 */
export const useFavoritePromptsController: (
	props: Omit<AssistanceServiceInjectedParams, 'assistanceServiceInjectedParams'> &
		AssistanceServiceInputParam,
) => UseFavoritePromptsControllerResult = createHookWithAssistanceService(
	({
		assistanceServiceInjectedParams: { assistanceService },
	}: UseFavoritePromptsControllerProps): UseFavoritePromptsControllerResult => {
		const favoritePrompts = useCallback(
			(payload: FavoritePromptsRequest) => assistanceService.favoritePrompts(payload),
			[assistanceService],
		);
		return { favoritePrompts };
	},
);
